import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _hm from './_hm';
import * as _ht from './_ht';

export const N = (pz: {
  sPz: _ht.dz,
  abtz?: {
    sc: _ht.s,
  },
  cz?: {
    text?: _ht.s,
    tgt?: _ht.s,
  },
  boxStlz?: _ht.dz,
}) => {

  const _sc = pz.abtz?.sc ?? 'lt5';

  return (
    _cr.c(BoxC.N, {
      boxStlz: {
//        ... a(`dh/mainHdr dw/f fd/ccc sc/lt5`),
        ... a(`dh/mainHdr dw/f fd/ccc sc/${_sc}`),
        ... pz.boxStlz,
      },
      boxClds: [
        _cr.c(TextC.N, {
          text: 
            _hm.f(pz.cz?.text) ?
              pz.cz?.text
            : pz.sPz.crt.steps[0] == 0 ?
              `${pz.cz?.tgt}の一覧`
            : pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' ?
              `${pz.cz?.tgt}の追加`
            : pz.sPz.crt.steps[0] == 1 && _hm.i(pz.sPz.crt.phs, ['d', 'u']) ?
              `${pz.cz?.tgt}の確認・変更`
            : pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'h' ?
              `${pz.cz?.tgt}の履歴`
            : ``,
          textStlz: a(`tb tc/lt1 ts/xl`),
        })
      ]
    })
  );
}